module.exports = __webpack_public_path__ + "img/logo-datakairos.0d0fed38.svg";